export default "__VITE_ASSET__BdOns69$__"